$( document ).ready(function() {

	$('.hamburger-menu').on('click', function() {
			$('.bar').toggleClass('animate');
			$('nav').toggleClass('open');
	});


	var $document = $(document),
	    $element = $('header'),
	    className = 'hasScrolled',
			classShow = 'show';

	$document.scroll(function() {
	  if ($document.scrollTop() >= 190) {

	    $element.addClass(className);
	  }
		if ($document.scrollTop() >= 590) {
 	    $element.addClass(classShow);
 	  }
		if ($document.scrollTop() <= 190) {
			$element.removeClass(className);
			$element.removeClass(classShow);
 	  }

	});

	});
